"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _context = _interopRequireDefault(require("./context"));

var _timeSync = _interopRequireDefault(require("time-sync"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TimeProvider = function TimeProvider(props) {
  var timeSyncFallback = (0, _react.useRef)(null);

  if (!props.timeSync && !timeSyncFallback.current) {
    timeSyncFallback.current = new _timeSync.default();
  }

  var timeSync = props.timeSync || timeSyncFallback.current;
  var timeContext = (0, _react.useMemo)(function () {
    return {
      getCurrentTime: _timeSync.default.getCurrentTime,
      getTimeLeft: _timeSync.default.getTimeLeft,
      addTimer: timeSync.addTimer,
      createCountdown: timeSync.createCountdown
    };
  }, [timeSync]);
  (0, _react.useEffect)(function () {
    return function () {
      if (!props.timeSync) {
        timeSync.removeAllTimers();
        timeSync.stopAllCountdowns();
      }
    };
  }, [props.timeSync, timeSync]);
  (0, _react.useEffect)(function () {
    function handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        timeSync.revalidate();
      }
    }

    var listenerSet = false;

    if (typeof document !== "undefined" && typeof document.visibilityState !== "undefined") {
      document.addEventListener("visibilitychange", handleVisibilityChange);
      listenerSet = true;
    }

    return function () {
      if (listenerSet) {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      }
    };
  }, [timeSync]);
  return /*#__PURE__*/_react.default.createElement(_context.default.Provider, {
    value: timeContext
  }, props.children);
};

TimeProvider.propTypes = {
  children: _propTypes.default.node,
  timeSync: _propTypes.default.object
};
var _default = TimeProvider;
exports.default = _default;